/**
 * Reads the injected config, or an empty object when nothing was injected (unit tests, and
 * any serving path that forgot to inject — callers must treat every field as optional).
 */
export function readRuntimeConfig() {
    return window.__RUNTIME_CONFIG__ ?? {};
}
